import React from "react";
import { Transfer as AntTransfer } from "antd";
import type { GetProp, TransferProps as AntTransferProps } from "antd";

type TransferItem = GetProp<AntTransferProps, "dataSource">[number];

export interface DataType {
  key: string;
  title: string;
  description: string;
  tag: string;
}

export interface TransferRenderProps {
  direction: "left" | "right";
  filteredItems: TransferItem[];
  onItemSelect: (key: string, selected: boolean) => void;
  onItemSelectAll: (dataSource: React.Key[], checkAll: boolean | "replace") => void;
  selectedKeys: React.Key[];
  disabled: boolean | undefined;
}

export interface TransferProps extends AntTransferProps<TransferItem> {
  renderContent: (props: TransferRenderProps) => React.ReactNode;
  titles?: [React.ReactNode, React.ReactNode];
  locale?: {
    itemUnit?: string;
    itemsUnit?: string;
    searchPlaceholder?: string;
    notFoundContent?: React.ReactNode;
  };
}

// Customize Table Transfer
export const Transfer: React.FC<TransferProps> = (props) => {
  const { renderContent, titles, locale, ...restProps } = props;
  
  // Configuración por defecto en español
  const defaultLocale = {
    itemUnit: "elemento",
    itemsUnit: "elementos",
    searchPlaceholder: "Buscar aquí",
    notFoundContent: "Sin resultados",
    ...locale,
  };

  return (
    <AntTransfer 
      style={{ width: "100%" }} 
      titles={titles}
      locale={defaultLocale}
      {...restProps}
    >
      {({
        direction,
        filteredItems,
        onItemSelect,
        onItemSelectAll,
        selectedKeys: listSelectedKeys,
        disabled: listDisabled,
      }) => {
        return renderContent({
          direction,
          filteredItems,
          onItemSelect,
          onItemSelectAll,
          selectedKeys: listSelectedKeys,
          disabled: listDisabled,
        });
      }}
    </AntTransfer>
  );
};
